import SliderInput from "../SliderInput";

interface StrokeWidthSliderProps {
  value: number;
  onChange: (value: number) => void;
}

export default function StrokeWidthSlider({
  value,
  onChange
}: StrokeWidthSliderProps) {
  const handleChangeStrokeWidth = (value: number) => {
    let newValue = Number(value);
    if (newValue > 5) newValue = 5;
    if (newValue < 1) newValue = 1;

    onChange(Math.round(newValue));
  };

  const handleChangeStrokeWidthSlider = (values: number[]) => {
    const newValue = Math.round(values[0]);
    if (newValue >= 1 && newValue <= 5) {
      onChange(newValue);
    }
  };

  const strokeWidthValue = [Math.max(1, Math.min(5, value || 1))];
  const strokeWidthInputValue = Math.max(
    1,
    Math.min(5, Math.round(value || 1))
  );

  return (
    <div className="flex flex-col gap-2 w-full">
      <p className="text-xs text-txtPlaceholder">Stroke</p>
      <SliderInput
        valueSlider={strokeWidthValue}
        onChangeSlider={handleChangeStrokeWidthSlider}
        valueInput={strokeWidthInputValue}
        onChangeInput={handleChangeStrokeWidth}
        max={5}
      />
    </div>
  );
}
